import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Cart } from 'src/models/DTO/cart/cart';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { WholeCart } from 'src/models/DTO/cart/wholeCart';
import { UserDTO } from 'src/models/DTO/user/user';
import { UpdateCartLineAmountModel } from 'src/models/requestModels/cart/updateCartLineAmountModel';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ToastService } from 'src/services/core/toast/toast.service';
import { CartService } from 'src/services/request/cart/cart.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-basecart',
  templateUrl: './basecart.component.html',
  styleUrls: ['./basecart.component.css']
})
export class BasecartComponent extends HistoryBaseComponent implements OnInit {


  private _cart?: WholeCart;
  private _cartLinePerOrganisation:  {[key: string]: CartLine[]} = {};
  private _cartTotalPerOrganisation:  {[key: string]: number} = {};
  private _cartSelectedPerOrganisation:  {[key: string]: boolean} = {};
  private _cartLines: {[key: string]: CartLine} = {};
  private bsOffcanvas: any;
  private _loggedUser?: UserDTO;

  public cartURL: string = 'bottomtabs/cart';


  constructor(
    private cartService: CartService,
    private imageService: ImagesService,
    private orderStateService: OrederStateService,
    private router: Router,
    private userStateService: LoggedUserService,
    protected location: Location,
    private toastService: ToastService,
    private localStorage: LocalstorageService,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this.userStateService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
      if (this._loggedUser?.data?.cart) {
        this.loadCart();
      }
    })
  }

  ngOnInit(): void {
  }


  private selectAll() {
    this.toggle(true);
    this.recalculateSelected();
  }

  private loadCart(){
    this._cart = this._loggedUser!.data.cart;
    this._cart!.lines.forEach(line => {
      this._cartLines[line.uuid] = line;
      this.imageService.getImagesForProduct("SKU", line.sku.uuid).subscribe(image => {
        if (image.data.length) {
          line.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
        }
        else {
          this.imageService.getImagesForProduct("PRODUCT", line.sku.product.uuid).subscribe(image => {
            line.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
          })
        }
      })
    })
    this.filterCartLines();
  }

  private filterCartLines() {
    this._cartTotalPerOrganisation = {};
    this._cartLinePerOrganisation = {};
    this._cart?.lines.forEach(line => {
      line.sku.options.forEach(option => {
        option.valueDecoded = option.option.values.find(allValues => allValues.uuid == option.value)?.value
      })
      line.sku.options.forEach(option => {
        if (!option.valueDecoded) {
          option.valueDecoded = option.value
        }
      })
      if (this._cartLinePerOrganisation[line.sku.product.organisation.uuid]) {
        this._cartLinePerOrganisation[line.sku.product.organisation.uuid].push(line)
        this._cartTotalPerOrganisation[line.sku.product.organisation.uuid] += Number.parseFloat(this.getPriceForCartLinePerAmount(line)) * line.quantity;
      }
      else {
        this._cartLinePerOrganisation[line.sku.product.organisation.uuid] = [line];
        this._cartTotalPerOrganisation[line.sku.product.organisation.uuid] = Number.parseFloat(this.getPriceForCartLinePerAmount(line)) * line.quantity;
      }
    })
    this.selectAll();
  }

  private recalculateSelected() {
    Object.keys(this._cartLinePerOrganisation).forEach(orgKey => {
      this._cartSelectedPerOrganisation[orgKey] = true
      this._cartLinePerOrganisation[orgKey].forEach(product => {
        if (!product.selected) {
          this._cartSelectedPerOrganisation[orgKey] = false
        }
        this._cart?.lines.forEach(line => {
          if (line.uuid == product.uuid) {
            line.selected = product.selected;
          }
        })
        this._cartLines[product.uuid].selected = product.selected
      })
    })
  }



  private getPriceForCartLinePerAmount(cartLine: CartLine) {
    let pricing = cartLine.sku.product.pricing.sort((pricingA, pricingB) => pricingA.quantity_from - pricingB.quantity_from)
    let priceToReturn = pricing[pricing.length - 1].price_per_piece;
    let productUUID = cartLine.sku.product.uuid;
    let quantity = 0;
    this.cart?.lines.forEach(line => {
      if (line.sku.product.uuid == productUUID) {
        quantity += line.quantity;
      }
    })
    for (const price of pricing) {
      if (price.quantity_from <= quantity && price.quantity_to >= quantity) {
        priceToReturn = price.price_per_piece;
      }
    }
    return priceToReturn;
  }

  get cart() {
    return this._cart;
  }

  get cartLinePerOrganisation() {
    return this._cartLinePerOrganisation;
  }

  get cartTotalPerOrganisation() {
    return this._cartTotalPerOrganisation;
  }

  get cartSelectedPerOrganisation() {
    return this._cartSelectedPerOrganisation;
  }

  get cartLines() {
    return this._cartLines;
  }

  get numberOfCartLines() {
    return this.cart?.lines.length || 0;
  }

  get isAllSelected() {
    let isSelected = true;
    Object.keys(this._cartLinePerOrganisation).forEach(orgKey => {
      this._cartLinePerOrganisation[orgKey].forEach(product => {
        if (!product.selected) {
          isSelected = false;
        }
      });
    });
    return isSelected;
  }

  get allOrgs() {
    return Object.keys(this._cartTotalPerOrganisation);
  }

  get totalSelected() {
    let value = 0;
    this.cart?.lines.forEach(line => {
      if (line.selected) {
        value += Number.parseFloat(this.getPriceForCartLinePerAmount(line)) * line.quantity;
      }
    });
    return value.toFixed(2);
  }

  get currentLink() {
    return this.localStorage.getLocalStorageItem(Config.bottomTapPageKey) || 'bottomtabs/home';
   }

  get screenStyle() {
    if (this.totalSelected) {
      return "position: absolute; top: 95px;  overflow-y: scroll;"
    }
    return "position: absolute; top: 95px;  overflow-y: scroll;"
  }

  isProductAvailable(productPerOrg: CartLine) {
    return !productPerOrg.sku.product.deleted_at && productPerOrg.sku.product.state == Config.activeState;
  }

  removeLine(productPerOrg: CartLine, orgs: string) {
    this.cartService.deleteCartLine(this.cart!.uuid, productPerOrg.uuid).subscribe(() => {
      this._cartLinePerOrganisation[orgs] = this.cartLinePerOrganisation[orgs].filter(product => product.uuid != productPerOrg.uuid);
      this._cart!.lines = this._cart!.lines.filter(cartLine => cartLine.uuid != productPerOrg.uuid);
      this._loggedUser!.data.cart!.lines = this._cart!.lines.filter(cartLine => cartLine.uuid != productPerOrg.uuid);
      this.filterCartLines();
    })
  }

  pricingInfo(cartLine: CartLine) {
    let price = this.getPriceForCartLinePerAmount(cartLine);
    let priceAsString =  Number.parseFloat(price).toFixed(2);
    return  cartLine.quantity + ' x ' + priceAsString + ' лв.';
  }

  goToProduct(productPerOrg: CartLine) {
    this.router.navigate(['product/' + productPerOrg.sku.product.uuid + '/' + 'none'])
  }

  decreaseAmount(productPerOrg: CartLine, orgs: string) {
    if (productPerOrg.quantity == 1) return;
    productPerOrg.quantity--;
    this.userStateService.addNewUser(this._loggedUser!);
    let cartLineUpdateRecord: UpdateCartLineAmountModel = {
      line_uuid: productPerOrg.uuid,
      new_quantity: productPerOrg.quantity
    }
    this.cartService.updateCartLine(this._cart!.uuid, cartLineUpdateRecord).subscribe(() => {
      this.filterCartLines();
    })
  }

  increaseAmount(productPerOrg: CartLine) {
    if (Number.parseInt(productPerOrg.sku.available_quantity) == productPerOrg.quantity) return;
    productPerOrg.quantity++;
    this.userStateService.addNewUser(this._loggedUser!);
    let cartLineUpdateRecord: UpdateCartLineAmountModel = {
      line_uuid: productPerOrg.uuid,
      new_quantity: productPerOrg.quantity
    }
    this.cartService.updateCartLine(this._cart!.uuid, cartLineUpdateRecord).subscribe(() => {
      this.filterCartLines();
    })
  }

  goToCategories() {
    this.router.navigate(["categories"])
  }

  toggle(value: boolean) {
    Object.keys(this._cartLinePerOrganisation).forEach(orgKey => {
      this._cartLinePerOrganisation[orgKey].forEach(product => {
        product.selected = value;
      });
    });
  }

  getPriceAsFixedString(cartLine: CartLine) {
    if (!cartLine.price_per_piece) return '00.00';
    let price = this.getPriceForCartLinePerAmount(cartLine);
    let priceCalculated =  Number.parseFloat(price) * cartLine.quantity
    let fixedPrice = priceCalculated.toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray;
  }

  getTotalPriceAsFixedString(price: string) {
    if (!price) return '00.00';
    let fixedPrice = Number.parseFloat(price).toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray[0] + '.' +priceArray[1];
  }

  getUnitPriceBase(cartLine: CartLine): number {
    const raw = this.getPriceForCartLinePerAmount(cartLine); // existing logic
    return Number(raw) || 0;
  }

  getLineTotalBase(cartLine: CartLine): number {
    return this.getUnitPriceBase(cartLine) * (Number(cartLine.quantity) || 0);
  }

  pricingInfoText(cartLine: CartLine): string {
    const qty = Number(cartLine.quantity) || 0;
    return `${qty} x`;
  }

  getOrgTotalBase(orgKey: string): number {
    const total = this._cartTotalPerOrganisation?.[orgKey];
    return Number(total) || 0;
  }

  get totalSelectedBase(): number {
    return Number(this.totalSelected) || 0;
  }

  continue() {
    console.log(this._cart);
  }

  allToggle(event: any) {
    this.toggle(event.target.checked)
    this.recalculateSelected();
  }

  orgToggle(event: any, orgUUID: string) {
    this._cartSelectedPerOrganisation[orgUUID] = event.target.checked;
    this._cartLinePerOrganisation[orgUUID].forEach(product => {
      product.selected = event.target.checked;;
    });
    this.recalculateSelected();
  }

  productToggle(event: any, productUUId: string) {
    Object.keys(this._cartLinePerOrganisation).forEach(orgKey => {
      this._cartLinePerOrganisation[orgKey].forEach(product => {
        if (product.uuid == productUUId) {
          product.selected = event.target.checked;
        }
      })
    })
    this._cartLines[productUUId].selected = event.target.checked;
    this.recalculateSelected();
  }

  createOrder() {
    for (let line of this._cart!.lines) {
      if (line.selected && !this.isProductAvailable(line)) {
        this.toastService.warning("Моля премахнете изчерпаните продукти")
        return;
      }
    }
    this._cart!.lines.forEach(line => {
      if (!line.selected) {
        this.cartService.deleteCartLine(this._cart!.uuid, line.uuid);
      }
    })
    this.orderStateService.addNewOrderInfo(
      {
        isNewAdrres: false,
        isNewPaymentMethod: false,
        isNewInvoiceAddress: false,
        toCarrierOffice: false,
        toAddress: true,
        personalInvoice: false,
        companyInvoice: false,
        cardPayment: true,
        cashPayment: false,
        checkedCartLines: this._cart!.lines.filter(line => line.selected),
        cart: this._cart,
      }
    );
    this.router.navigate(['order/details']);
  }
}
